import type { PersonType } from "@whatslly/types/Person";
import type { TemplateType } from "@whatslly/types/GetTemplatesResponse";
import type { UserType } from "@whatslly/types/User";
import type { IPromiseBasedObservable } from "mobx-utils";
import type { QueryResponseType } from "@whatslly/types/QueryResponse";
export const TEMPLATE_DATA_TRANSFER_TYPE = "tuvis/templateId";

export type TemplateStoreData = {
  templatesUrl: string;
  templateEditorUrl: string;
  os: string;
  templates: TemplateType[];
};

export interface IImTemplatesStore {
  user?: UserType;
  favoriteTemplates: Set<string>;
  templateFilesCache: Map<string, File[]>;
  allowEditTemplate: boolean;
  height: string;
  allowCreateTemplate: boolean;
  templatesData: IPromiseBasedObservable<TemplateStoreData>;
  showOnlyOwnByMe: boolean;
  previewdTemplate?: TemplateType;
  containerSizeIsBig: boolean;
  isOpen: boolean;
  toggleFavoriteTemplate(templateId: string): void;
  getTemplateId(person: PersonType, message: { isSentByMe?: boolean; id?: string; text?: string }): Promise<string | undefined>;
  getTemplates(): Promise<TemplateStoreData>;
  openPreviewMsg(template: TemplateType): void;
  useTemplate(template: TemplateType): Promise<void>;
  closeTemplateWidget(): void;
  setShowOnlyOwnByMe(val: boolean): void;
  setProps(props: { queryResponse: QueryResponseType }): void;
  closePreviewMsg(): void;
}

export const ImTemplatesStoreSymbol = Symbol.for("IImTemplatesStore");

export const formatTemplateMsg = (msg: string) => {
  const regex = /&#(.*?);/g;
  const symbols = msg.match(regex);
  if (!symbols || symbols.length === 0) {
    return msg;
  }
  const symbolsArray: { orgVal: string; symbol: string }[] = symbols
    .map((val) => {
      try {
        const uniCodeChars = Number(val.replace("&#", "").replace(";", ""));
        return { orgVal: val, symbol: String.fromCodePoint(uniCodeChars) };
      } catch {
        return undefined as unknown as { orgVal: string; symbol: string };
      }
    })
    .filter(Boolean);

  if (symbolsArray.length === 0) {
    return msg;
  }

  return symbolsArray.reduce<string>((newMsg, { orgVal, symbol }) => {
    newMsg = newMsg.replaceAll(orgVal, symbol);
    return newMsg;
  }, msg);
};
